import React, { Component } from 'react';
import { Container, Row, Col, Card, Button } from 'reactstrap';

export class SocialSection extends Component {
  static displayName = SocialSection.name;

  socialLinks = [
    {
      name: "WhatsApp",
      icon: "fab fa-whatsapp",
      url: "https://wa.me/573023772270",
      color: "#25D366"
    },
    {
      name: "Instagram",
      icon: "fab fa-instagram",
      url: "https://www.instagram.com/iglesiacbr",
      color: "#E4405F"
    },
    {
      name: "Facebook",
      icon: "fab fa-facebook",
      url: "https://www.facebook.com/iglesiacbr",
      color: "#1877F2"
    },
    {
      name: "YouTube",
      icon: "fab fa-youtube",
      url: "https://www.youtube.com/@iglesiacbr",
      color: "#FF0000"
    },
    {
      name: "Spotify",
      icon: "fab fa-spotify",
      url: "https://open.spotify.com/show/1JktaU8tH1Q77IzgnmzulC",
      color: "#1DB954"
    },
    {
      name: "Apple Podcast",
      icon: "fab fa-apple",
      url: "https://podcasts.apple.com/es/podcast/red-de-adoradores/id1833274568",
      color: "#000000"
    }
  ];

  podcasts = [
    {
      title: "Red de Adoradores",
      description: "Nuestro podcast semanal con mensajes de fe y esperanza",
      platform: "Spotify",
      color: "#1DB954"
    },
    {
      title: "Red de Adoradores",
      description: "También disponible en Apple Podcasts",
      platform: "Apple Podcast",
      color: "#000000"
    }
  ];

  render() {
    return (
      <section className="section">
        <Container>
          <h2 className="section-title">Síguenos en Redes Sociales</h2>
          <Row>
            <Col lg="8" className="mx-auto">
              <Card className="p-4 mb-5">
                <div className="text-center mb-4">
                  <h4 style={{ color: 'var(--dark-blue)' }}>
                    Conéctate con Nuestra Comunidad
                  </h4>
                  <p className="lead">
                    Mantente al día con nuestras actividades, mensajes y eventos
                  </p>
                </div>
                <Row className="justify-content-center">
                  {this.socialLinks.map((social, index) => (
                    <Col lg="4" md="6" className="mb-3" key={index}>
                      <a 
                        href={social.url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-decoration-none"
                      >
                        <Card 
                          className="text-center p-3 h-100"
                          style={{ 
                            border: 'none',
                            transition: 'all 0.3s ease',
                            cursor: 'pointer'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-5px)';
                            e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.15)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 5px 15px rgba(0,0,0,0.1)';
                          }}
                        >
                          <div className="card-body">
                            <i 
                              className={`${social.icon} fa-2x mb-2`}
                              style={{ color: social.color }}
                            ></i>
                            <h6 className="card-title mb-0" style={{ color: 'var(--dark-blue)' }}>
                              {social.name}
                            </h6>
                          </div>
                        </Card>
                      </a>
                    </Col>
                  ))}
                </Row>
              </Card>
            </Col>
          </Row>

          {/* CBR Social y Podcasts */}
          <Row>
            <Col lg="12">
              <h3 className="text-center mb-4" style={{ color: 'var(--dark-blue)' }}>
                CBR Social
              </h3>
            </Col>
            <Col lg="6" className="mb-4">
              <Card className="h-100">
                <div className="card-body text-center">
                  <i className="fas fa-podcast fa-3x mb-3" style={{ color: 'var(--primary-blue)' }}></i>
                  <h5 className="card-title">Nuestros Podcasts</h5>
                  <p className="card-text">
                    Escucha nuestros mensajes y reflexiones semanales
                  </p>
                  <div className="mt-3">
                    {this.podcasts.map((podcast, index) => (
                      <div key={index} className="mb-2">
                        <a 
                          href={podcast.platform === "Spotify" ? this.socialLinks[4].url : this.socialLinks[5].url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-outline-primary btn-sm me-2"
                          style={{ borderRadius: '20px' }}
                        >
                          <i 
                            className={`${podcast.platform === "Spotify" ? "fab fa-spotify" : "fab fa-apple"} me-1`}
                            style={{ color: podcast.color }}
                          ></i>
                          {podcast.platform}
                        </a>
                      </div>
                    ))}
                  </div>
                </div>
              </Card>
            </Col>
            <Col lg="6" className="mb-4">
              <Card className="h-100">
                <div className="card-body text-center">
                  <i className="fas fa-heart fa-3x mb-3" style={{ color: 'var(--secondary-gold)' }}></i>
                  <h5 className="card-title">Donaciones</h5>
                  <p className="card-text">
                    Apoya la obra del Señor y el crecimiento de nuestra iglesia
                  </p>
                  <Button 
                    color="secondary" 
                    className="mt-3"
                    style={{ borderRadius: '25px' }}
                  >
                    <i className="fas fa-donate me-2"></i>
                    Donar Ahora
                  </Button>
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }
}
